import {renderAppointmentDetailsTable, renderThanksContainer} from "../utils/templates";
import {t} from "../i18n";

export default class ConfirmStep {
    constructor() {
        this.id = 'confirm';
        this.title_key = 'thank_title';
    }

    init({$, state, data, emit }) {
        this.$ = $;
        this.state = state;
        this.data = data;
        this.emit = emit;
    }

    render(container) {
        const $html = this.$(renderThanksContainer({config: this.data.config, isClass: this.state.isClass}));
        container.html($html);

        const $detailsTable = $html.find('.appointment-details-table');
        renderAppointmentDetailsTable({
            table: $detailsTable,
            state: this.state
        });

        /**
         * TODO:
         *  - change text on `thank_button`
         *  - we may have this.state.appointmentLink
         *  - Back to {Account Name}
         *  ```
         *          <button class="primary-button" id="thank-button" style="--clr-primary: var(--clr-secondary);">${t('my_appointments')}</button>
         *         container.find('#back-button').on('click', e => {
         *             window.open(this.data.apiRoutes.homePage);
         *         });
         *  ```
         */

        if(this.state.noAccount) {
            container.find('#thank-button').hide();
        } else {
            container.find('#thank-button').on('click', (e) => {
                const accountUrl = this.data.apiRoutes.accountAppointment;
                // NOT window.open('_blank'): Instagram/Facebook in-app browsers
                // silently drop it (user-confirmed dead button). A real anchor
                // click with target=_top is treated as user navigation � works
                // in webviews AND breaks out of the vanity-domain iframe shell,
                // making the account dashboard first-party for cookies.
                const a = document.createElement('a');
                a.href = accountUrl;
                a.target = '_top';
                a.rel = 'noopener';
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
        }
    }
}